export const text = ["text-sm", "font-thin", "p-1", "italic"];
export const link = (theme?: string) => ["text-primary", "italic", "font-bold", theme ?? ""];
